var map = {
	"./default/wa-background.png": "./src/assets/themes/default/wa-background.png",
	"./urbe/wa-background.png": "./src/assets/themes/urbe/wa-background.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/themes sync recursive ^\\.\\/.*\\/wa\\-background\\.png$";